import { render, staticRenderFns } from "./time-limits.vue?vue&type=template&id=fdd36ee0&scoped=true"
import script from "./time-limits.vue?vue&type=script&lang=js"
export * from "./time-limits.vue?vue&type=script&lang=js"
import style0 from "./time-limits.vue?vue&type=style&index=0&id=fdd36ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd36ee0",
  null
  
)

export default component.exports